import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MediaKit from "@/pages/MediaKit";

function App() {
  return (
    <div className="App min-h-screen bg-white text-[#37352f]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MediaKit />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
